import { render, staticRenderFns } from "./addPageBrochure.vue?vue&type=template&id=e4b59658&scoped=true"
import script from "./addPageBrochure.vue?vue&type=script&lang=js"
export * from "./addPageBrochure.vue?vue&type=script&lang=js"
import style0 from "./addPageBrochure.vue?vue&type=style&index=0&id=e4b59658&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4b59658",
  null
  
)

export default component.exports